export class ProveedorReferenceCode {
   proveedorReferenciasId: string;
   proveedorId: string;
   emisorId: string;
   nombre: string;
   xmlReferencia: string;
   tipoReferencia: string;
}
